import {gsap} from "gsap";
import {IBetWayWinData} from "../server/IKMDData";
import {KMDGameAssets} from "../KMDGameAssets";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {KennethMustDie} from "../KennethMustDie";

export class KMDWinAmount extends PIXI.Container {

    constructor() {
        super();
        this.name = "KMDWinAmount";

        this.y = KennethMustDie.MAIN_REELS_TOP;
    }

    public showWinAmountNWays(betWay: IBetWayWinData): void {
        const amount: PIXI.BitmapText = new PIXI.BitmapText(betWay.multipliedAmount.toFixed(2), {
                fontName: KMDGameAssets.BITMAP_FONT_WIN_COUNT_UP,
                fontSize: 16
            }),
            ways: PIXI.Text = new PIXI.Text(betWay.numberOfCombinations + " " + KennethMustDie.apiPlugin.translations.translate(betWay.numberOfCombinations > 1 ? "WAYS WON" : "WAY WON"), {
                fontFamily: "Open Sans",
                fontWeight: FontWeight.BOLD,
                fontSize: 30,
                align: "center",
                fill: "#ffbe64",
                stroke: "black",
                strokeThickness: 3,
                lineJoin: "round"
            });
        let reel: number = -1,
            row: number = 0;

        for (let reelId: number = betWay.reelWinPositions.length - 1; reelId >= 2; reelId--) { // looping from last reel to 3rd reel, as min win length is 3.
            for (let rowId: number = 0; rowId < betWay.reelWinPositions[reelId].length; rowId++) {
                if (betWay.reelWinPositions[reelId][rowId]) {
                    reel = reelId;
                    row = rowId;

                    break;
                }
            }

            if (reel > -1) {
                break;
            }
        }

        while (amount.textWidth > 140) {
            amount.fontSize--;
        }

        // #495
        if (reel === (KennethMustDie.REELS_NUM - 1)) {
            while (ways.width > 140) {
                ways.style.fontSize--;
            }
        } else if (reel === (KennethMustDie.REELS_NUM - 2)) {
            while (ways.width > 400) {
                ways.style.fontSize--;
            }
        }

        amount.position.set(((reel * KennethMustDie.SYMBOL_WIDTH) + KennethMustDie.SYMBOL_WIDTH / 2), ((row * KennethMustDie.SYMBOL_HEIGHT) - 20));
        amount.pivot.set(amount.width / 2, amount.height / 2);

        ways.position.set(amount.x, amount.y + 40);
        ways.anchor.set(0.5);

        this.animateItems(ways, amount);
    }

    private animateItems(ways: PIXI.Text, amount: PIXI.BitmapText): void {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            this.addChild(ways, amount);
        });
        tl.to([ways, amount], {
            duration: 0.5,
            y: "-=75"
        });

        tl.to([ways, amount], {
            duration: 0.1,
            alpha: 0
        }, 0.4);

        tl.add(() => {
            this.removeChildren();
        });

        // #528 -> pt 10
        tl.timeScale(0.5);
    }
}